import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Lesson } from './Lesson';

// Standalone page: it only depends on the lessons endpoint, so it also works for branches that are not listed in the app
const LessonPage = () => {
  const { id } = useParams();

  return (<>
    <Helmet>
      <title>Aula - Atacante App</title>
    </Helmet>

    {id && <Lesson scheduleId={id} />}
  </>);
}

export {
  LessonPage,
}
